import { FC, useEffect, useState } from 'react';
import {
  DropdownMenuTrigger,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@features/ui';
import { TOption } from '@src/types';
import { DropDownIcon } from '@features/ui/icons';

interface DropdownAccountProps {
  options: TOption[];
  defaultValue?: string;
  placeHolder?: string;
  onPress?: (option: TOption) => void;
}

export const DropdownAccount: FC<DropdownAccountProps> = ({
  options,
  defaultValue,
  onPress,
  placeHolder = 'Select an option',
}) => {
  const [selectedOption, setSelectedOption] = useState<TOption | null>(null);

  useEffect(() => {
    const findDefaultValue = options.find(
      (item) => item.value === defaultValue
    );

    setSelectedOption(findDefaultValue ?? null);
  }, [defaultValue, options]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div
          className={
            'flex items-center gap-x-5 cursor-pointer hover:bg-accent rounded-[4px]'
          }
        >
          <p className={'text-2xl font-medium text-link'}>
            {selectedOption?.label ?? placeHolder}
          </p>
          <DropDownIcon />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={'bg-[#414141]'}>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            className={`${
              selectedOption?.value === option.value
                ? 'bg-[#007bff] text-white'
                : ''
            }`}
            onSelect={() => {
              setSelectedOption(option);
              onPress?.(option);
            }}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
